const cdnUrl = process.env.NEXT_PUBLIC_CDN_URL || "https://cdn-sdotid.adg.id";

export default cdnUrl;
